import { Component, OnInit } from '@angular/core';
import { CardModule } from 'primeng/card';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ShopService } from '../service/shop.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TagModule } from 'primeng/tag';
import { DatePipe } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { Router } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BadgeModule } from 'primeng/badge';
import { FormService } from '../../../utils/dynamic-form/form.service';
import { FiltersComponent } from '../../../utils/filters/filters.component';
import { FieldConfig, FieldType } from '../../../utils/dynamic-form/form.type';

import { UserService } from '../../user/services/user.service';
import { User } from '../../user/models/user.type';
import { Util } from '../../../utils/util';
import { AutoCompleteModule } from 'primeng/autocomplete';

@Component({
  selector: 'app-shop-list',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CardModule,
    TableModule,
    ButtonModule,
    TranslateModule,
    TagModule,
    DatePipe,
    InputTextModule,
    SelectModule,
    TooltipModule,
    TagModule,
    BadgeModule,
    AutoCompleteModule,
  ],
  templateUrl: './shop-list.component.html',
  styleUrl: './shop-list.component.scss',
  providers: [DialogService, DatePipe],
})
export class ShopListComponent implements OnInit {
  shops: any[] = [];
  user: User = this.userService.getUser();
  headers = [
    {
      id: 'shopName',
      value: 'table.name',
    },
    {
      id: 'shopStatus',
      value: 'shop.compteStatus',
      sortColumn: 'shopStatus.statusName',
      type: 'status',
    },
    {
      id: 'legalEntityName',
      value: 'table.legalEntityName',
    },
    {
      id: 'shopCode',
      value: 'ID(s) BOMP',
    },
    {
      id: 'channel',
      value: 'table.canal',
    },
    {
      id: 'shopCanImport',
      value: "table.importRight",
      options: ['Autorisé', 'Non autorisé'],
      type: 'tag',
    },
    {
      id: 'lastImportDate',
      value: 'table.lastImport',
      // type: 'date',
    },
    {
      id: 'scoreRef',
      value: 'shop.scoreRef',
      type: 'score',
      tooltip: 'shop.refTooltip',
    },
    {
      id: 'scoreMedia',
      value: 'shop.scoreMedia',
      type: 'score',
      tooltip: 'shop.mediaTooltip',
    },
    {
      id: 'scoreAd',
      value: 'shop.scoreAd',
      type: 'score',
      tooltip: 'shop.adTooltip',
    },
  ];

  fields: FieldConfig[] = [
    {
      label: 'global.distributionChannel',
      selectedItemPrefix: true,
      value: this.user?.defaultChannel,
      enbeddedLabel: true,
      name: 'channelCode',
      type: FieldType.select,
      options: this.user?.relatedChannels,
      optionLabel: 'channelName',
    },
    {
      label: "shop.searchText",
      type: FieldType.input,
      placeholder: "shop.searchText",
      name: 'search',
      iconPrefix: 'pi pi-search',
    },
    {
      label: 'Filtrer',
      type: FieldType.button,
      subType: 'outlined',
      name: 'filter',
      iconPrefix: 'pi pi-filter',
      width: '120px',
      action: 'dialog',
      classes: 'right',
    },
  ];
  selectedShops = [];
  ref: DynamicDialogRef | undefined;
  filters = [];
  appliedFilters = {};
  tags = [];
  form: FormGroup = new FormGroup({});
  rows = 100;
  searchFilters;
  selectAll = false;
  totalRecords;
  searchKeyword;
  searchKeywords;
  loading = true;
  searchData: any = {
    searchKeyWord: '',
    offset: 0,
    itemSize: this.rows,
    orderColumn: null,
    orderDirection: null,
  };
  disabledExportButton = false;
  constructor(
    private readonly shopService: ShopService,
    private readonly translate: TranslateService,
    private readonly formService: FormService,
    private readonly dialogService: DialogService,
    private readonly datePipe: DatePipe,
    private readonly router: Router,
    private readonly userService: UserService,
  ) {}

  ngOnInit(): void {
    this.form = this.formService.toFormGroup(this.fields);
    

    this.filters = [
      {
        type: 'select',
        name: 'shopStatus',
        header: this.translate.instant('global.status'),
        values: [
          {
            data: 'ACTIVE',
            label: this.translate.instant('global.activated'),
          },
          {
            data: 'PENDING',
            label: this.translate.instant('global.pending'),
          },
          {
            data: 'INACTIVE',
            label: this.translate.instant('global.deactivated'),
          },
        ],
      },
      {
        type: 'select',
        name: 'shopCanImport',
        header: this.translate.instant('global.importRight'),
        values: [
          {
            data: true,
            label: this.translate.instant('global.authorized'),
          },
          {
            data: false,
            label: this.translate.instant('global.notAuthorized'),
          },
        ],
      },
      {
        type: 'dateTime',
        name: 'lastImportDate',
        header: this.translate.instant('table.lastImport'),
      },
      {
        type: 'slider',
        name: 'scoreRef',
        header: this.translate.instant('shop.scoreRef'),
      },
      {
        type: 'slider',
        name: 'scoreMedia',
        header: this.translate.instant('shop.scoreMedia'),
      },
      {
        type: 'slider',
        name: 'scoreAd',
        header: this.translate.instant('shop.scoreAd'),
      },
    ];
  }

  rowClick(shop) {
    //NOSONAR
    const selection = globalThis.getSelection();
    if (selection && selection.toString().length > 0) {
      return; // Ne pas rediriger si du texte est sélectionné
    }
    this.router.navigate(['operator/shop/' + shop.shopCode]);
  }

  openFilterModal() {
    this.ref = this.dialogService.open(FiltersComponent, {
      header: this.translate.instant('global.filter'),
      dismissableMask: true,
      focusOnShow: false,
      closable: true, 
      data: { filters: this.filters, appliedFilters: this.appliedFilters },
      width: '65vw',
      height: '75vh',
      modal: true,
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
    });
    this.ref.onClose.subscribe((data) => {
      this.handleFilterData(data);
    });
  }

  handleFilterData(data) {
    this.selectAll = false;
    if (!data) {
      return;
    }
    this.tags = [];
    for (let key in data) {
      if (data[key]) {
        const header = this.headers.find((filter) => filter.id === key).value;
        this.appliedFilters[key] = data[key];
        if (key === 'lastImportDate') {
          this.handleDateFilter(data, header, key);
        } else if (key === 'scoreMedia' || key === 'scoreRef' || key === 'scoreAd') {
          this.handleScoreFilter(data, header, key);
        } else {
          this.handleAuxFilter(data, header, key);
        }
      }
    }

     this.onLazyLoad({
      first: 0,
      rows: this.rows,
      sortField: null,
      sortOrder: null,
    });
  }

  handleAuxFilter(data, header, key) {
    if (data[key]?.length > 0) {
      const selectedValues = data[key].map((item) => item.label).join(', ');
      if (data[key].length > 4) {
        this.tags.push({
          name: key,
          header: header,
          value: data[key],
          valueString: `${data[key].length} ${this.translate.instant('global.selectedElements')}`,
        });
      } else {
        this.tags.push({
          name: key,
          header: header,
          value: data[key],
          valueString: ` ${selectedValues}`,
        });
      }
    }
  }

  handleScoreFilter(data, header, key) {
    if (data[key][0] > 0 || data[key][1] < 100) {
      this.tags.push({
        name: key,
        header: header,
        value: data[key],
        valueString: `${data[key][0]} - ${data[key][1]}`,
      });
    }
  }

  handleDateFilter(data, header, key) {
    if (data[key] && (data[key][0] != null || data[key][1] != null)) {
      let tag = `${this.datePipe.transform(
        data[key][0],
        'dd-MM-yyyy : HH:mm',
      )} - ${this.datePipe.transform(data[key][1], 'dd-MM-yyyy : HH:mm')}`;
      if(data[key][0] == null && data[key][1] != null) {
        tag = `Avant ${this.datePipe.transform(data[key][1], 'dd-MM-yyyy : HH:mm')}`;
      } else if(data[key][1] == null && data[key][0] != null) {
        tag = `Après ${this.datePipe.transform(data[key][0], 'dd-MM-yyyy : HH:mm')}`;
      }
      this.tags.push({
        name: key,
        header: header,
        value: data[key],
        valueString: tag,
      });
    }
  }

  removeFilter(value) {
    this.tags = this.tags.filter((tag) => tag.name !== value);
    delete this.appliedFilters[value];
    this.selectAll = false;
    this.onLazyLoad({
      first: 0,
      rows: this.rows,
      sortField: null,
      sortOrder: null,
    });
  }

  clearFilters() {
    this.tags = [];
    this.appliedFilters = {};
    this.selectAll = false;
    this.selectedShops = [];
    this.onLazyLoad({
      first: 0,
      rows: this.rows,
      sortField: null,
      sortOrder: null,
    });
  }

  removeSelection() {
    this.selectAll = false;
    this.selectedShops = [];
  }

  filterGlobal(event, canal = null) {
    this.selectAll = false;
    this.selectedShops = [];
    if (canal) {
      this.fields[0].value = event;
    } else {
      this.searchKeyword = this.form.get('search').value.join(' ');
      this.searchKeywords = this.form.get('search').value;
    }
    this.onLazyLoad({
      first: 0,
      rows: this.rows,
      sortField: null,
      sortOrder: null,
    });
  }

  onFilterKeydown(event: KeyboardEvent, filter: any) {
    const control = this.form.get(filter.name);
    const input = event.target as HTMLInputElement;
    if (event.key === 'Enter') {
      // committer le texte saisi comme token, vider le champ, puis filtrer
      const value = (input.value ?? '').trim();
      if (value) {
        const current: string[] = control.value ?? [];
        if (!current.includes(value)) {
          control.setValue([...current, value]);
        }
        input.value = '';
      }
      this.filterGlobal(event);
      return;
    }
    Util.addTokenOnSeparatorKey(event, control);
  }

  onFilterPaste(event: ClipboardEvent, filter: any) {
    const control = this.form.get(filter.name);
    if (Util.pasteTokens(event, control)) {
      this.filterGlobal(null);
    }
  }

  getSeverity(status: string) {
    return Util.getSeverity(status);
  }

  selectAllShops() {
    this.selectAll = true;
  }

  selectionChange() {
    this.selectAll = false;
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    const currentPage = event.first / event.rows;
    this.searchData.offset = currentPage;
    this.searchData.itemSize = event.rows;
    this.searchData.orderColumn = event.sortField;
    this.searchData.orderDirection = event.sortOrder === 1 ? 'ASC' : 'DESC';
    this.getPaginatedShops();
  }

  getPaginatedShops() {
    this.loading = true;
    let data = this.initData();
    this.shopService.getPaginatedShopsWithFilers(data).subscribe({
      next: (response) => {
        this.shops = response['content'];
        this.totalRecords = response['totalElements'];
         for (let shop of this.shops) {
          shop.channel = shop.shopChannel.channelName;
        }
        this.loading = false;
      },
      error: (error) => {
        console.log(error);
      }
    })
  }

  initData() {
    let data = {};
    data = this.getCommonData();
    data['shopCodes'] = this.selectedShops.map((shop) => shop.shopCode);
    
    data['offset'] = this.searchData.offset;
    data['itemSize'] = this.searchData.itemSize;
    data['orderColumn'] = this.searchData.orderColumn;
    data['orderDirection'] = this.searchData.orderDirection
    return data;
  }

  getCommonData() {
    let data = {};
     if (this.appliedFilters['lastImportDate']?.length == 2) {
        if (this.appliedFilters['lastImportDate'][0] == null && this.appliedFilters['lastImportDate'][1] == null) {
          data['lastImportDate'] = [];
        } else {
          data = {
            lastImportDate: [
              this.datePipe.transform(Util.toUTC(this.appliedFilters['lastImportDate'][0]), 'dd/MM/yyyy HH:mm'),
              this.datePipe.transform(Util.toUTC(this.appliedFilters['lastImportDate'][1]), 'dd/MM/yyyy HH:mm'),
            ],
          };
        }
      } else {
        data['lastImportDate'] = [];
      }

    data['scoreRef'] = this.appliedFilters['scoreRef'] ?? [];
    data['scoreMedia'] = this.appliedFilters['scoreMedia'] ?? [];
    data['scoreAd'] = this.appliedFilters['scoreAd'] ?? [];
    data['shopStatus'] = this.appliedFilters['shopStatus']?.map((status) => status.data) ?? [];
    data['shopCanImport'] = this.appliedFilters['shopCanImport']?.map((imports) => imports.data) ?? [];
    data['channel'] = this.fields[0].value.channelCode ?? null;
    data['searchKeyword'] = this.searchKeywords ?? [];
    return data;
  }

  exportShops() {
    this.disabledExportButton = true;
    let data = {};
    if (this.selectAll) {
      data = this.getCommonData()
    } else {
      data['shopCodes'] = this.selectedShops.map((shop) => shop.shopCode);
    }

    this.shopService.exportShops(data).subscribe({
      next: (response) => {
        this.disabledExportButton = false;
        Util.handleExportSuccess(response)
      },
      error: Util.handleExportError,
    });
  }
}
